import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-loader"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "#e7e7e7",
  class: "w-6 h-6 app-loader__icon"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
  })
], -1)

import { defineAsyncComponent, ref, computed } from 'vue';
import { forEach } from 'lodash';
import i18n from '@/plugins/i18n';

// Composables
import { useStore } from 'vuex';
import { useThemeColors } from '@/composables/useThemeColors';

// Components
import DefaultLayout from '@/layouts/DefaultLayout/DefaultLayout.vue';

// Types
import { useRoute } from 'vue-router';
import { IAppSetting } from '@/@types/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// Modules
const $route = useRoute();
const store = useStore();
const colors = useThemeColors();

const { t } = i18n.global;

const loading = ref<boolean>(true);
const rootAppElement = ref<HTMLElement | null>(null);

const layout = computed((): string => {
  const component = $route.meta?.layout
    ? defineAsyncComponent(
      async () =>
        await import(
          `@/layouts/${$route.meta.layout}/${$route.meta.layout}.vue`
        ),
    )
    : null;
  return component || DefaultLayout;
});

// const appTheme = computed((): string => (
//   store.getters['config/getAppTheme']
// ));

const appSettings = computed((): IAppSetting => (
  store.getters['config/getAppSettings']
));

const changeFavicon = (iconUrl: string): void => {
  const favicon = document.getElementById('favicon') as HTMLLinkElement;
  if (favicon) {
    favicon.href = iconUrl;
  }
};

const init = async () => {
  const root = document.documentElement;
  const body = document.querySelector('body');
  const defaultFavicon = '/img/favicon.png';

  try {
    loading.value = true;
    await store.dispatch('config/fetchAppSettings');
  } finally {
    forEach(colors.value, (value, key): void => {
      root.style.setProperty(`--${key}`, value);
    })

    const appIconFile = appSettings?.value?.appIconFile ?? defaultFavicon;
    changeFavicon(appIconFile)

    // if (appTheme.value === 'dark') {
    //   body?.classList.add('theme-dark');
    // } else {
      body?.classList.add('theme-light');
    // }

    const hexToRGB = (hex: string) => {
      const r: number = parseInt(hex.slice(1, 3), 16);
      const g: number = parseInt(hex.slice(3, 5), 16);
      const b: number = parseInt(hex.slice(5, 7), 16);
      return `${r}, ${g}, ${b}`;
    };

    const variablesList = [
      'Error',
      'Background',
      'Primary',
      'OnSecondary',
      'Surface',
      'SurfaceBlanket', // For 20% rgba
      'SelectionPrimary1', // 85% rgba
      'SelectionPrimary2', // 63% rgba
      'SelectionPrimary3', // 25% rgba
      'SelectionSecondary', // 35% rgba
      'SelectionSecondary2', // 10% rgba
      'Accent',
    ];

    variablesList.map((variable: string) => {
      const hex = getComputedStyle(root).getPropertyValue(`--${variable}`);
      const rgb = hexToRGB(hex);

      root.style.setProperty(`--${variable}RGB`, rgb);
    });

    loading.value = false;
  }
}

// Hooks

init();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_TheNotifications = _resolveComponent("TheNotifications")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootAppElement",
    ref: rootAppElement,
    class: "app-wrapper"
  }, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_unref(t)('main_loading')), 1)
        ]))
      : (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        })),
    _createVNode(_component_TheNotifications)
  ], 512))
}
}

})